// extracted by mini-css-extract-plugin
export default {"content":"emailmodal_content__qw45a","text":"emailmodal_text__gvW9y"};